import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";
import { resetTourEdit } from "../reducer/tourEditReducer";

function TourManagementInclusionPage() {
  const [inclustionError, setInclusionError] = useState("");
  const [exclutionError, setExclutionError] = useState("");
  const [Error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { packageData } = useSelector((state: RootState) => state.tour);
  const { tourEdit, id } = useSelector((state: RootState) => state.edit);
  const progressref = useRef(5);

  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);
  const { createPrePackage } = usePackage();
  const [loading, setLoading] = useState(false);

  console.log("packageDAta", packageData);

  useOnLoadPage({ tabActive: "create" });

  useEffect(() => {
    if (location.state && location.state.packageData) {
      dispatch(setPackageData(location.state.packageData));
    }
  }, [location.state, dispatch]);

  const cleanArray = (arr?: string[]) =>
    Array.isArray(arr)
      ? arr.map((item) => item.trim()).filter((item) => item !== "")
      : [];

  const onContinue = () => {
    const hasValidInclusions =
      packageData.inclusions &&
      cleanArray(packageData.inclusions).some((item) => item !== "");

    if (!hasValidInclusions) {
      setInclusionError("Please complete this field.");
      return;
    }

    dispatch(
      setPackageData({
        ...packageData,
        inclusions: cleanArray(packageData.inclusions),
      })
    );

    dispatch(addActiveTab(Paths.tourManagementPackageGuideInfo));
    navigate(Paths.tourManagementPackageGuideInfo);
  };

  const onSave = async () => {
    const hasValidInclusions =
      packageData.inclusions &&
      cleanArray(packageData.inclusions).some((item) => item !== "");

    if (!hasValidInclusions) {
      setInclusionError("Please complete this field.");
      return;
    }

    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
    };

    const updatedPackageData2 = {
      ...packageData,
    };

    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      if (tourEdit) {
        dispatch(resetTourEdit());
        dispatch(setPackageData(updatedPackageData2));
        navigate(Paths.manageProductDetails.replace(":id", id), {
          state: { fromEdit: true },
        });
        return;
      } else {
        await createPrePackage(updatedPackageData);
        navigate(Paths.welcome);
      }

      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  console.log("packageda", packageData);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageKeywords);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={6} />

        <div className={Classname.detail}>
          <span className={Classname.title}>What Is Included?</span>
          <p className={Classname.description}>
            List all the features that are included inthe price so customers
            understand the value for money of your activity. Start a new line
            for each features.
          </p>
          <textarea
            name=""
            id=""
            cols={30}
            rows={10}
            className={Classname.textarea}
            placeholder="Please Enter your details"
            value={packageData.inclusions?.join("\n") || ""}
            onChange={(e) => {
              const inclusionsArray = e.target.value.split("\n");

              dispatch(
                setPackageData({
                  ...packageData,
                  inclusions: inclusionsArray,
                })
              );

              if (inclustionError) setInclusionError("");
            }}
          />
          {inclustionError && (
            <span className="mt-2 text-sm text-red-600">{inclustionError}</span>
          )}
          <div className="flex gap-3 items-center">
            <span className={Classname.title}>What Is not Included?</span>
            <span className="mt-4">(optional)</span>
          </div>
          <p className={Classname.description}>
            Name what customers need to pay extra for or what they may expect to
            see that isn't included in the price. This allows customers to
            appropriately set their expectations. Start a new line for each not
            included features.
          </p>
          <textarea
            name=""
            id=""
            cols={30}
            rows={10}
            className={Classname.textarea}
            placeholder="Please Enter your details"
            value={packageData.exclusions?.join("\n") || ""}
            onChange={(e) => {
              const exclusionsArray = e.target.value.split("\n");

              dispatch(
                setPackageData({
                  ...packageData,
                  exclusions: exclusionsArray,
                })
              );
            }}
          />

          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              {!tourEdit && (
                <button
                  className={Classname.continueButton}
                  onClick={onContinue}
                >
                  Continue
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementInclusionPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6",
  description: "flex text-base mb-4",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  highlightButton:
    "font-bold flex items-center gap-2 cursor-pointer text-primary1 py-4",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
